const denialReasonOptions = [
  {
    value: "INCORRECT_ACCOUNT_TYPE_REQUESTED",
    label: "Incorrect Account Type Requested",
    description: "The requested account type exceeds the individual's job responsibilities, organizational authorities, or approved scope of use."
  },
  {
    value: "NOT_AUTHORIZED",
    label: "Not Authorized",
    description: "The individual does not meet eligibility requirements for access connected to a specific organization or agency affiliation."
  },
  {
    value: "IDENTITY_CANNOT_BE_VERIFIED",
    label: "Identity Cannot Be Verified",
    description: "Sufficient information was not provided to verify the requestor's identity."
  },
  {
    value: "CONFLICT_WITH_SECURITY_OR_POLICY_REQUIREMENTS",
    label: "Conflict with Security or Policy Requirements",
    description: "Granting access would conflict with agency security policies, system rules of behavior, acceptable use policies, or applicable regulations."
  },
  {
    value: "DUPLICATE_OR_EXISTING_ACCESS",
    label: "Duplicate or Existing Access",
    description: "The individual already holds appropriate access, or the request duplicates an existing account."
  },
  {
    value: "ACCOUNT_MISUSE_OR_PRIOR_VIOLATION",
    label: "Account Misuse or Prior Violation",
    description: "Prior misuse of system access or failure to comply with security requirements may result in denial or revocation."
  },
  {
    value: "OTHER",
    label: "Other",
    description: "Access denied for reasons not listed above. Additional explanation will be provided as appropriate."
  }
];

export function getDenialReasonDisplayText(reasonValue) {
  const selectedOption = denialReasonOptions.find((option) => option.value === reasonValue);
  if (!selectedOption) {
    return reasonValue;
  }
  return `${selectedOption.label} - ${selectedOption.description}`;
}

export default denialReasonOptions;
